const newsConstantsEn = {
  newsTitle: 'News',
  arabicTitle: 'ARABIC TITLE',
  englishTitle: 'ENGLISH TITLE',
  publishDate: 'PUBLISH DATE',
  newsStatus: 'STATUS',
  newsStatusPublished: 'Published',
  newsStatusUnpublished: 'Unpublished',
  totalNews: 'News',
  deleteNewsTitle: 'Delete News',
  deleteNewsContent: 'Are you sure you want to delete this New from the admin panel ?',
  snackbarDeletedMsg: 'Deleted Successfully',
};
export default newsConstantsEn;
